import { render, staticRenderFns } from "./ElInternalEmbedBlock.vue?vue&type=template&id=5f96c29b"
import script from "./ElInternalEmbedBlock.vue?vue&type=script&lang=js"
export * from "./ElInternalEmbedBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports